module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/gameserverkings.961b80c6.svg";